import React from 'react'
import styles from './styles.module.css'
import cn from 'classnames'

export default function Table({ children, className, maxHeight = '65vh', wrapperStyle, ...props }) {

  const classNames = cn([styles.table, className])

  return (
    <div className={classNames} style={{ maxHeight: maxHeight, ...wrapperStyle }} >
      <table {...props}>
        {children}
      </table>
    </div>
  )
}
